import { render, staticRenderFns } from "./DeveloperNewForm.vue?vue&type=template&id=3e507a97"
import script from "./DeveloperNewForm.vue?vue&type=script&lang=js"
export * from "./DeveloperNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports